<div class="header mt-md-5">
  <a [routerLink]="'/client-questionnaires'" href=""><i class="fa fa-chevron-left"></i> Retourner aux questionnaires
client</a>

<div class="header-body">

  <div class="row align-items-center calculation-status-bar">
    <div class="col">

      <!-- Title -->
      <h1 class="header-title d-flex align-items-center">
        {{ getClientName() }} <small class="ms-3">({{ getClientEmail() }})</small>
        <span [class.bg-light]="this.clientQuestionnaireStatus === 'CREATED'"
          [class.bg-success]="this.clientQuestionnaireStatus === 'FINALIZED'"
          [class.bg-warning]="this.clientQuestionnaireStatus === 'IN_PROGRESS'"
          class="ms-5 badge rounded-pill bg-warning"
          style="font-size: 70%;"

        >{{ getStatusText() }}</span>
      </h1>

      <div class="mt-4">
        <div class="d-block d-sm-inline mb-3 mb-sm-0">
          <i class="fad fa-poll-h"></i>
          <strong class="ms-2">{{ getTitleText() }}</strong>
        </div>

        <div class="ms-sm-5 d-block d-sm-inline">Dernière modification: <strong
        class="lastModifiedText">{{ getLastModifiedText() }}</strong></div>
      </div>

      @if (this.clientQuestionnaireResponse.status !== clientQuestionnaireStatusEnum.Finalized) {
        <div class="mt-4">
          Envoyez le lien ci-dessous à votre client pour qu'il puisse remplir le questionnaire.
          <div class="input-group mb-3" style="max-width: 800px;">
            <input [value]="getLink()" aria-describedby="button-addon2" aria-label="Recipient's username"
              class="form-control" disabled placeholder="Recipient's username"
              readonly type="text">
            <button (click)="copyToClipboard()" class="btn btn-primary" id="button-addon2" type="button"><i
            class="far fa-copy"></i>
          </button>
        </div>
        @if (hasCopied) {
          <div class="text-success"><i class="fas fa-check"></i> Copié</div>
        }
        <a [href]="mailtoLink()" class="btn btn-light mt-3"
          target="_blank"><i class="fas fa-paper-plane"></i> Envoyer par courriel</a>
        </div>
      }


    </div>
  </div> <!-- / .row -->

  <div class="row">
    <div class="col-12">
      <app-alert-messages></app-alert-messages>
    </div>
  </div>

  <div class="row align-items-center">
    <div class="col">

      <!-- Nav -->
      <!--                <ul class="nav nav-tabs nav-overflow header-tabs">-->
      <!--                    <li class="nav-item">-->
      <!--                        <a [routerLink]="'/calculations/' + (calculationKeyname) + '/' + (_calculationId)"-->
      <!--                           id="form-tab-link" class="nav-link"-->
      <!--                           [class.active]="this.menuService.menuItems['/calculations/:calculationKeyname/:id'].isActive">-->
      <!--                            questionnaire-->
    <!--                        </a>-->
  <!--                    </li>-->

  <!--                    <li class="nav-item">-->
  <!--                        <a [routerLink]="'/calculations/' + (calculationKeyname) + '/' + (_calculationId) + '/results'"-->
  <!--                           id="results-tab-link" class="nav-link"-->
  <!--                           [class.active]="this.menuService.menuItems['/calculations/:calculationKeyname/:id/results'].isActive">-->
  <!--                            Résultats-->
<!--                        </a>-->
<!--                    </li>-->
<!--                    <li class="nav-item">-->
<!--                        <a [routerLink]="'/calculations/' + (calculationKeyname) + '/' + (_calculationId) + '/errors'"-->
<!--                           id="errors-tab-link" class="nav-link position-relative ms-2"-->
<!--                           [class.active]="this.menuService.menuItems['/calculations/:calculationKeyname/:id/errors'].isActive">-->
<!--                            Erreurs <span class="badge rounded-pill ms-2"-->
<!--                                          [class.text-bg-danger]="numberOfErrors > 0"-->
<!--                                          [class.text-bg-secondary]="numberOfErrors == 0">{{numberOfErrors}}</span>-->
<!--                        </a>-->
<!--                    </li>-->
<!--                </ul>-->

</div>
</div>
</div>
</div>

<div class="container mb-5">
  <div class="row align-items-center">
    <div class="col">

      <!-- Nav -->
      <ul class="nav nav-tabs nav-overflow header-tabs">
        <li class="nav-item">
          <a (click)="this.isMainSpouseTab = true" [class.active]="this.isMainSpouseTab" class="nav-link"
            id="form-tab-link">
            Formulaire principal
          </a>
        </li>
        <li class="nav-item">
          <a (click)="this.isMainSpouseTab = false" [class.active]="this.isMainSpouseTab === false" class="nav-link"
            id="form-tab-spouse-link">
            Formulaire conjoint
          </a>
        </li>
      </ul>

    </div>
  </div>
</div>

<div [hidden]="isMainSpouseTab === false" class="container">
  <app-quebec-2022-tax-questionnaire
    [advancedForm]="advancedForm"
    [baseSpouseForm]="advancedForm"
  [isMainSpouse]="true"></app-quebec-2022-tax-questionnaire>
</div>

<div [hidden]="isMainSpouseTab === true" class="container">
  @if ((advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw || advancedForm.value.civilStatus === civilStatusEnum.Married) && advancedForm.value.isSpouseTaxPrepared) {
    <app-quebec-2022-tax-questionnaire
      [advancedForm]="advancedForm"
      [baseSpouseForm]="advancedForm.formElements.spouseTaxForm"
    [isMainSpouse]="false"></app-quebec-2022-tax-questionnaire>
  }

  @if (!(advancedForm.value.civilStatus === civilStatusEnum.LivingCommonLaw || advancedForm.value.civilStatus === civilStatusEnum.Married) || advancedForm.value.isSpouseTaxPrepared === false) {
    <div
      class="alert alert-warning"
      role="alert">
      <i class="fas fa-exclamation-triangle"></i> Pour remplir la declaration du conjoint veuillez répondre oui à
      la question 'Est-ce que la déclaration du conjoint sera produite par notre cabinet?'.
    </div>
  }
</div>

